import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AdministrationGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const isAuthenticatedForAdmin = this.authService.isAuthenticatedForAdmin();
      if (isAuthenticatedForAdmin) {
        return true;
      } else {
        this.router.navigate(['unauthorized']);
        return false;
      }
  }
}

